module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/titlepg.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "title4"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLEGORICAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALE OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVELOPING")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADERSHIP")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KILLS IN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USINESS AND IN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('b', [_vm._v("S. Mosby Marble")])]), _vm._v(" "), _c('p', {
    staticClass: "publisheri"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("NEW YORK")]), _vm._v(" "), _c('p', {
    staticClass: "publishers"
  }, [_vm._v("LONDON • NASHVILLE • MELBOURNE • VANCOUVER")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0